<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useServiceStore } from '@/stores/serviceStore';
import { useRequestsStore } from '@/stores/storeRequests';

import img_0 from '@/assets/img/courts/court_0.webp';
import img_1 from '@/assets/img/courts/court_1.webp';
import img_2 from '@/assets/img/courts/court_2.webp';
import img_3 from '@/assets/img/courts/court_3.webp';
import img_4 from '@/assets/img/courts/court_4.webp';
import img_5 from '@/assets/img/courts/court_4.webp';
import img_6 from '@/assets/img/courts/court_5.webp';
import img_7 from '@/assets/img/courts/court_6.webp';
import img_8 from '@/assets/img/courts/court_5.webp';
// import img_9 from '@/assets/img/courts/court_9.webp';

const courtImages = [img_0, img_1, img_2, img_3, img_4, img_5, img_6, img_7, img_8];

const storeService = useServiceStore();
const storeRequests = useRequestsStore();
const router = useRouter()

let currentDate = new Date();

let formattedDate = currentDate.toISOString().split('T')[0];  

let nextDay = new Date(currentDate);
nextDay.setDate(currentDate.getDate() + 1);

let formattedNextDay = nextDay.toISOString().split('T')[0];

const nextSreen = async (courtId) => {
    const parametrs = {
        court_id: courtId,
        start_date: formattedDate,
        end_date: formattedNextDay,
        limit: 24,
        offset: 0
    }
    await storeRequests.getCourtsSlots(parametrs);
    if(!storeRequests.responseOk) return;
    sessionStorage.setItem("courtIdToken", courtId);
    storeService.goToScreen(storeService.screens.selectDate)
    router.push({ hash: `#${storeService.screens.selectDate}`})
    storeRequests.responseOk = null
}

const previousSreen = () => {
    storeService.goToScreen(storeService.screens.services)
    storeRequests.responseError = null
    router.push({ hash: `#${storeService.screens.services}`})
    sessionStorage.removeItem('courtIdToken')
    storeService.clearSessionCourtTimes()
    storeService.clearSessionSelectedCourt()
}

onMounted( async () => {
    storeService.hideScreenLoader()
})

</script>

<template>
    <div class="services-container">
        <div class="container">
            <button class="services-btn-back" @click="previousSreen">
                <svg width='24' height='24'><use href='#back_icon'></use></svg>
                <span>Назад</span>
            </button>
            <h2 class="service-title">Выберите корт</h2>
            
        </div>
            <div class="service">
                <div class="service__slider slider">
                    <swiper-container
                        class="service__swiper"
                        centered-slides="true"
                        speed="800"
                        initialSlide= "0"
                        :navigation="{
                            nextEl: '.slider__next',
                            prevEl: '.slider__prev',
                        }" 
                        :breakpoints="{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10
                            },
                            769: {
                                slidesPerView: 2,
                                spaceBetween: 100
                            },
                         
                            1441: {
                                slidesPerView: 2,
                                spaceBetween: 230
                            }
                        }"
                    >
                        <swiper-slide  class="service__slide" v-for="(court, index) of storeRequests.listCourts" :key="court.id">
                            <div class="service__slide-item">
                                <div class="service__slide-image">
                                    <img class='full-img' width='670' height='426' :src='courtImages[index]' alt='изображение'>
                                </div>
                                <div class="service__slide-footer">
                                    <div class="service__slide-name">{{ court.title }}</div>
                                    <div class="service__slide-price">
                                        <span>Стоимость:</span>
                                        <span>от {{ court.price }} ₽</span>
                                    </div>
                                    <p class="form-text-error" style="margin-bottom: 10px;" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
                                    <button 
                                        class="service__slide-btn btn --full" 
                                        @click="nextSreen(court.id), storeService.addCheckedCourt(court.price, court.title, courtImages[index]), storeService.clearSessionCourtTimes()"
                                    >
                                        <span v-if="!storeRequests.loaderBtn">Выбрать</span>
                                        <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                                    </button>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper-container>
                    <div class="slider__controls">
                        <button class="slider__prev slider__btn">
                            <svg width='40' height='40'><use href='#slider__prev'></use></svg>
                        </button>
                        <button class="slider__next slider__btn">
                            <svg width='40' height='40'><use href='#slider__next'></use></svg>
                        </button>
                    </div>
                </div>
            </div>
            
    </div>
</template>
<style lang='scss' scoped>
swiper-container::part(container) {
    padding-bottom: 15rem;
}



</style>